import { Link } from "react-router-dom";
import { useStore } from "../lib/store";
import { ProductCard } from "../components/site/ProductCard";

export default function Wishlist() {
  const { wishlist, byId, clearWishlist, addToCart, toggleWish } = useStore();
  const items = wishlist.map((id) => byId[id]).filter(Boolean);

  const moveAll = () => items.forEach((p) => { addToCart(p, { size: p.sizes?.[2] ?? p.sizes?.[0] ?? null, color: p.colors?.[0] ?? null }); toggleWish(p); });

  return (
    <main data-testid="wishlist-page" className="mx-auto max-w-7xl px-4 sm:px-8 pt-12 pb-28">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow text-gold-deep">Saved for later</p>
          <h1 className="mt-2 font-script text-6xl sm:text-7xl">Your Wishlist</h1>
        </div>
        {items.length > 0 && (
          <div className="flex gap-3">
            <button data-testid="wishlist-move-all-button" onClick={moveAll} className="btn-luxe">Move all to bag</button>
            <button data-testid="wishlist-clear-button" onClick={clearWishlist} className="btn-ghost">Clear</button>
          </div>
        )}
      </div>
      {items.length ? (
        <div data-testid="wishlist-grid" className="mt-12 grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 lg:grid-cols-4">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      ) : (
        <div data-testid="wishlist-empty-state" className="py-28 text-center">
          <p className="font-display text-3xl italic text-plum/80">Tap the heart on anything you love.</p>
          <Link to="/shop" className="btn-luxe mt-8">Discover pieces</Link>
        </div>
      )}
    </main>
  );
}
